import { render } from "./TopNavBar.vue?vue&type=template&id=417dd2ea&scoped=true&ts=true"
import script from "./TopNavBar.vue?vue&type=script&lang=ts"
export * from "./TopNavBar.vue?vue&type=script&lang=ts"

import "./TopNavBar.vue?vue&type=style&index=0&id=417dd2ea&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417dd2ea"]])

export default __exports__